module.exports = __webpack_public_path__ + "img/snipaste.7eb3e360.png";